/**
 * TPL ATC FX — two motion.dev ports on the buy button (.product-form__submit):
 *   "Dots morph button"          → while tpl-cart-event-bridge.js holds .is-loading
 *                                  the label becomes three pulsing dots (CSS), and
 *                                  "Added ✓" pops in on a spring.
 *   "Rolling text button"        → the idle label's letters roll upward on press,
 *                                  and "Added ✓" rolls in letter by letter.
 * The bridge owns the text (Adding… / Added ✓ / default); this file only reacts
 * to its writes through a MutationObserver, so the cart flow is untouched.
 */
(function () {
  'use strict';

  var EXPO = 'cubic-bezier(0.16, 1, 0.3, 1)';
  var ROLL_MS = 480;
  var STAGGER_MS = 18;

  function reducedMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }
  function supported() {
    return typeof Element !== 'undefined' && typeof Element.prototype.animate === 'function';
  }

  /* Damped spring → keyframes of scale. */
  function popFrames() {
    var k = 500, d = 12, w0 = Math.sqrt(k), z = d / (2 * w0), f = [];
    for (var i = 0; i <= 30; i++) {
      var t = (i / 30) * 0.6, wd = w0 * Math.sqrt(1 - z * z);
      var x = 1 - Math.exp(-z * w0 * t) * (Math.cos(wd * t) + (z * w0 / wd) * Math.sin(wd * t));
      var s = 0.7 + 0.3 * x;
      f.push({ transform: 'scale(' + s.toFixed(3) + ')', opacity: Math.min(1, x + 0.3).toFixed(3) });
    }
    return f;
  }

  /* Roll the letters of `el` upward once, then put the plain text back. */
  function roll(el, done) {
    if (!el || el.dataset.tplRolling === '1' || !supported() || reducedMotion()) { if (done) done(); return false; }
    var text = el.textContent;
    if (!text.trim()) { if (done) done(); return false; }
    el.dataset.tplRolling = '1';
    var frag = document.createDocumentFragment();
    var letters = [];
    text.split('').forEach(function (ch) {
      var b = document.createElement('span');
      b.className = 'tpl-roll__l';
      var glyph = ch === ' ' ? ' ' : ch;
      b.innerHTML = '<span>' + glyph + '</span><span aria-hidden="true">' + glyph + '</span>';
      frag.appendChild(b);
      letters.push(b);
    });
    el.textContent = '';
    el.appendChild(frag);
    el.classList.add('tpl-roll');
    var last = null;
    letters.forEach(function (b, i) {
      last = b.animate([{ transform: 'translateY(0)' }, { transform: 'translateY(-100%)' }], { duration: ROLL_MS, delay: i * STAGGER_MS, easing: EXPO, fill: 'forwards' });
    });
    var finish = function () {
      if (el.dataset.tplRolling !== '1') return;
      el.dataset.tplRolling = '0';
      /* Only restore if nothing else rewrote the label meanwhile. */
      if (el.querySelector('.tpl-roll__l')) { el.classList.remove('tpl-roll'); el.textContent = text; }
      if (done) done();
    };
    if (last) last.onfinish = finish;
    setTimeout(finish, ROLL_MS + letters.length * STAGGER_MS + 100);
    return true;
  }

  function pop(el) {
    if (!el || !supported() || reducedMotion()) return;
    el.animate(popFrames(), { duration: 600, easing: 'linear' });
  }

  function init(button) {
    if (!button || button.dataset.tplAtcFx === '1') return;
    button.dataset.tplAtcFx = '1';
    var label = button.querySelector('.btn-text');
    if (!label) return;
    var lastText = label.textContent.trim();

    /* Press → letters roll (only while idle). */
    button.addEventListener('pointerdown', function () {
      if (button.disabled || button.classList.contains('is-loading')) return;
      roll(label);
    });

    /* The bridge writes "Adding..." then "Added ✓" then the default label. */
    var mo = new MutationObserver(function () {
      if (label.dataset.tplRolling === '1') return;   // our own roll DOM
      var text = label.textContent.trim();
      if (text === lastText) return;
      lastText = text;
      if (/^added/i.test(text)) pop(label);   /* audit 2026-09-08: pop only, no second roll */
    });
    mo.observe(label, { childList: true, characterData: true, subtree: true });
  }

  function boot() {
    document.querySelectorAll('.product-form__submit').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  window.addEventListener('load', boot);

  window.TPLAtcFx = { roll: roll, pop: pop, init: init };
})();
